import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAC2Gik5hE3FPJSMaUQd7N5k0e9Z60xIy4",
  authDomain: "ecomm-banner-day.firebaseapp.com",
  projectId: "ecomm-banner-day",
  storageBucket: "ecomm-banner-day.firebasestorage.app",
  messagingSenderId: "571058939744",
  appId: "1:571058939744:web:d34a5f4d1e43936c3c6005",
  measurementId: "G-N1X171KW0F",
};

const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);

// Connect to the emulator when running locally
if (process.env.NODE_ENV === "development") {
  connectFunctionsEmulator(functions, "localhost", 5001);
}

export { functions, httpsCallable };